// Dependency
import React, { useEffect, useState } from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import SwiperCore, { Autoplay, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import UtilsService from "../../services/utils.service";
//import CookieConsent, { Cookies } from "react-cookie-consent";
import Img from "gatsby-image";
import swedenFlag from "../../images/sweden.svg";
import denmark from '../market-switcher/assets/denmark-flag.png';
import europe from '../market-switcher/assets/europe.png';
import norway from '../market-switcher/assets/norway.png';
import netherlands from '../market-switcher/assets/netherlands.png';
import unitedKingdom from '../market-switcher/assets/uk-flag.png';
// Components
//import MegaNav from '../mega-nav/mega-nav';
import { useCart } from "../../contexts/cart-context";
import SmallNav from "../mega-nav/small-nav";
import Countdown from "../countdown/countdown";

//Internationalization
import { useTranslation } from "react-i18next";

// Services
import Storage from '../../services/localStorage.service';
import GA from "../../services/ga.service";


// Styles
import 'swiper/scss';
import "swiper/css/effect-fade";
import * as headerStyles from './header.module.scss'

// Assets

//import loupe from "../../images/loupe.png";
// import GA from "../../services/ga.service";
// import fire from "../../images/snowman.png"

// Hooks
import useMediaQuery from '../../hooks/useMediaQuery';
import Search from "./search/search";
import MobileMenu from "./mobile-menu/mobilemenu";
import MoreMenu from "./mobile-menu/moreMenu";
import { globalHistory } from "@reach/router";


// install Swiper modules
SwiperCore.use([Autoplay, EffectFade]);

//GraphQL to get Dato data
// Template
const Header = (props) => {
    const { cart, toggleMiniCart } = useCart();
    const data = useStaticQuery(graphql`
      query {
        datoCmsHeader{
          _allWhiteLogoLocales{
            value{
              url
              fixed(height: 44) {
                ...GatsbyDatoCmsFixed
              }
            }
            locale
          }
          whiteLogo{
            fixed( height: 18){
                ...GatsbyDatoCmsFixed
            }
          }
          darkLogo{
            fixed( height: 18){
                ...GatsbyDatoCmsFixed
            }
          }
          saleLabelColor{
            hex
          }
          saleLabelBackground{
            hex
          }
          saleLabelText
          _allMenuLinksLocales{
            value{
              name
              url
              thumbnail{
                url
              }
              locale
              newWindow
              showMegaNav
              showSmallNav
            }
            locale
          }
          noticeMenuPerks{
            _allTextLocales {
              locale
              value
            }
          }
          noticeMenuActive
          noticeMenuColor{
            hex
          }
          noticeMenuBackground{
            hex
          }
          perks{
            _allTextLocales {
              locale
              value
            }
          }
          instagramText
        }
    }
        `)
    const headerData = data.datoCmsHeader;

    const [cartCount, setCartCount] = useState(cart.selection.totals.totalQuantity);

    useEffect(() => {
        return globalHistory.listen(({ action }) => {
            if (action === 'PUSH') {
                let hrq = window.hrq || [];
                hrq.push([
                    "reload"
                ]);
            }
        })
    }, [])

    const { t } = useTranslation();

    //TODO : Maybe change to get country from Layout to prevent wrong URL form build
    const locale = UtilsService.getLocaleFromUrl();

    const localeMap = {
        se: 'sv-SE',
        dk: 'da',
        eu: 'en',
        no: 'no',
        nl: 'nl',
        fr: 'en',
        uk: 'en-GB'
    }

    // Set state for notice banner
    let [isNoticeClosed, setIsNoticeClosed] = useState(Storage.getNoticeStatus());

    const closeNotice = () => {
        Storage.setNoticeStatus();
        setIsNoticeClosed(true);
    };

    // Keep track of dropdown state
    const [modalOpened, setModalopened] = useState(props.dropDownOpened);
    // Keep state of MegaNav
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [smalldropdownOpen, setSmalldropdownOpen] = useState(false);


    const openMeganav = (event, small) => {
        if (small) {
            setSmalldropdownOpen(true)
        } else {
            if (modalOpened) {
                closeMeganav(event);
                setModalopened(false);
                return;
            }
            if (event.target.nextElementSibling) {
                setDropdownOpen(true);
            }
        }
    };
    const closeMeganav = () => {
        setDropdownOpen(false);
        setSmalldropdownOpen(false);
    }

    useEffect(() => {
        setCartCount(cart.selection.totals.totalQuantity)
    }, [cart.selection.totals.totalQuantity])


    useEffect(() => {
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;
        let scrollDir = 'down';

        const nav = document.getElementById("cd-header-nav");
        const wrapper = document.getElementById("cd-header-nav-wrapper");

        const updateScrollDir = () => {
            const scrollY = window.pageYOffset;

            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            scrollDir = scrollY > lastScrollY ? "down" : "up";
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }

            const navHeight = nav.getBoundingClientRect().height;
            const topBorder = nav.getBoundingClientRect().top;

            if (window.outerWidth < 900) {
                // om scrollen är längre än höjden på nav
                if (topBorder < navHeight * -1) {
                    wrapper.classList.add(headerStyles.cdHeaderNavSd);
                    if (scrollDir === 'down') {
                        wrapper.classList.remove(headerStyles.cdHeaderNavSu)
                    } else {
                        wrapper.classList.add("cd-header-nav-fixed");
                        wrapper.classList.add(headerStyles.cdHeaderNavSu)
                    }
                } else if (topBorder >= 0) {
                    wrapper.classList.remove("cd-header-nav-fixed");
                    wrapper.classList.remove(headerStyles.cdHeaderNavSd)
                    wrapper.classList.remove(headerStyles.cdHeaderNavSu)
                }
            } else {
                topBorder >= 0
                    ? document.getElementById("cd-header-nav-wrapper").classList.remove("cd-header-nav-fixed")
                    : document.getElementById("cd-header-nav-wrapper").classList.add("cd-header-nav-fixed");
            }


        };

        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, []);


    let desktopMenu = headerData._allMenuLinksLocales.filter((desktopMenuLocale) => {
        return desktopMenuLocale.locale === localeMap[props.country];
    });

    const isTabletOrMobile = useMediaQuery(900)

    //Header Navbar Duplication
    const NavbarDuplicate = [1, 2, 3, 4, 5, 6];

    const flags = {
        se: swedenFlag,
        dk: denmark,
        eu: europe,
        no: norway,
        nl: netherlands,
        uk: unitedKingdom
    }

    return (
        <header className={`
            ${headerStyles.cdHeader}
            ${props.isHome === true ? `${headerStyles.cdHeaderHome} cd-header-home` : ''}
            ${props.isAbsolute === true ? headerStyles.cdAbsoluteHeader : ''}
            ${props.isSwedenHeader === true ? headerStyles.cdSwedenHeader : ''}`
        }
        >
            <div id="cd-header-nav" className={`${headerStyles.cdHeaderNav} cd-header-nav ${props.isCheckout === true ? `${headerStyles.cdCheckoutHeader} cd-checkout-header` : ''}`}>
                <div id="cd-header-nav-wrapper" className={`${headerStyles.cdHeaderNavWrapper} cd-header-nav-wrapper`}>
                    {headerData.noticeMenuActive ?
                        <div style={{ background: headerData.noticeMenuBackground.hex }} className={`${headerStyles.cdMarqueeWrapper}`}>
                            <div className={headerStyles.marquee}>
                                <div className={headerStyles.marquee__content}>
                                    {NavbarDuplicate.map((a, i) => {
                                        return (
                                            <ul key={i} className={headerStyles.listInline}>
                                                {headerData.noticeMenuPerks.map((perk) => {
                                                    return (perk._allTextLocales.map((perkLocale, index) => {
                                                        if (perkLocale.locale === localeMap[props.country]) return (
                                                            <>
                                                                <li
                                                                    style={{ color: headerData.noticeMenuColor.hex }}
                                                                    key={index} dangerouslySetInnerHTML={{ __html: perkLocale.value }}
                                                                >
                                                                </li>
                                                                <Countdown color={headerData.noticeMenuColor.hex} country={props.country} />
                                                            </>
                                                        )
                                                    }))
                                                })}
                                            </ul>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        :
                        <div className={headerStyles.cdHeaderTopBar}>
                            <div className={`${headerStyles.cdHeaderTopBarContent} cd-max-width cd-large-width`}>
                                <div className={`${headerStyles.cdHeaderTopBarItem} ${headerStyles.cdHeaderTopBarLeft}`}>
                                </div>
                                <div className={`${headerStyles.cdHeaderTopBarItem} ${headerStyles.cdHeaderTopBarMiddle}`}>
                                    <Swiper
                                        fadeEffect={{ crossFade: true }}
                                        effect={'fade'}
                                        loop={true}
                                        speed={1000}
                                        slidesPerView={1}
                                        autoplay={{
                                            delay: 3000
                                        }}
                                        grabCursor={true}
                                    >
                                        {headerData.perks.map((perk) => {
                                            return (perk._allTextLocales.map((perkLocale, index) => {
                                                if (perkLocale.locale === localeMap[props.country]) return (
                                                    <SwiperSlide key={index} className={headerStyles.swiperSlide}>
                                                        <div dangerouslySetInnerHTML={{ __html: perkLocale.value }}></div>
                                                    </SwiperSlide>
                                                )
                                            }))
                                        })}
                                    </Swiper>
                                </div>
                                <div className={`${headerStyles.cdHeaderTopBarItem} ${headerStyles.cdHeaderTopBarRight}`}>
                                    <Countdown country={props.country} />
                                </div>
                            </div>
                        </div>
                    }

                    <div className={headerStyles.cdHeaderWrapper}>
                        <div className={`${headerStyles.cdHeaderContent} cd-max-width cd-large-width`}>
                            <MobileMenu direction={'left'} country={props.country} />
                            <div className={headerStyles.cdCheckoutHeaderBack}>
                                <Link className="cd-dark-mode-dark" to={`/${props.country}/shop/`}><i className="material-icons">west</i> {t('miniCart.continueShopping')}</Link>
                            </div>
                            <div className={`${headerStyles.cdHeaderItem} ${headerStyles.cdHeaderLeft}`}>
                                <Link className={headerStyles.cdHeaderLogo} to={`/${props.country}/`} >
                                    <div className={headerStyles.cdDarkLogo}>
                                        <Img loading="eager" fadeIn={false} className="cd-logo" fixed={headerData.darkLogo.fixed} />
                                    </div>
                                    <div className={headerStyles.cdWhiteLogo}>
                                        <Img loading="eager" fadeIn={false} className="cd-logo" fixed={headerData.whiteLogo.fixed} />
                                    </div>

                                    {/*<span></span>*/}
                                    <p>{t('checkout.checkout')}</p>
                                </Link>
                                <div className={`${headerStyles.cdHeaderItem} ${headerStyles.cdHeaderMiddle}`}>
                                    <ul>
                                        {desktopMenu[0].value.map((menuLink, index) => {
                                            return (
                                                <li
                                                    key={index}
                                                    onClick={closeMeganav}
                                                    onMouseEnter={e => openMeganav(e, menuLink.showSmallNav && menuLink.showSmallNav)}
                                                    onMouseLeave={closeMeganav}
                                                >
                                                    {
                                                        menuLink.url.includes('https')
                                                            ? <a target="_blank" rel="noreferrer" href={menuLink.url}>{menuLink.name}</a>
                                                            : <Link
                                                                to={`/${props.country}${menuLink.url.includes('tb-open') ? menuLink.url : menuLink.url + '/'}`}
                                                                state={{ navIsOpen: true }}
                                                            >{menuLink.name}
                                                            </Link>
                                                    }
                                                    {
                                                        menuLink
                                                        && menuLink.showSmallNav
                                                        && <SmallNav
                                                            pages={headerData.smallPages}
                                                            locale={locale}
                                                            isOpen={smalldropdownOpen}
                                                        />
                                                    }
                                                </li>
                                            )
                                        })}
                                        <MoreMenu direction={'left'} country={props.country} />

                                    </ul>
                                </div>
                            </div>
                            <div className={`${headerStyles.cdHeaderItem} ${headerStyles.cdHeaderRight}`}>
                                <div className={headerStyles.cdHeaderLanguageSwitcherWrapper}>
                                    <button onClick={props.flyinToggle} className={headerStyles.cdHeaderLanguageSwitcher}>
                                        <img src={flags[props.country]} alt="Flag" />
                                        <p>{t('langSwitch.' + locale.country)}</p>
                                    </button>
                                </div>
                                <Search labelText={headerData.saleLabelText} labelBackground={headerData.saleLabelBackground.hex} color={headerData.saleLabelColor.hex} country={props.country} />
                                {!isTabletOrMobile || cart.selection.items.length === 0 ?
                                    <button className={`${headerStyles.cartButton}`} onClick={() => { toggleMiniCart() }}>
                                        <span className={headerStyles.cdMiniTotalsCount}>{cartCount}</span>
                                    </button>
                                    :
                                    <Link to={`/${props.country}/checkout/`}>
                                        <button onClick={() => GA.onCheckout(cart.selection.items, cart.selection.discounts.vouchers)} className={`${headerStyles.cartButton}`}>
                                            <span className={headerStyles.cdMiniTotalsCount}>{cartCount}</span>
                                        </button>
                                    </Link>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header